// extracted by mini-css-extract-plugin
export default {"cart":"cart_cart__BD8OC","mappedItems":"cart_mappedItems__5Cbm-","topDiv":"cart_topDiv__u1zaU"};